import { RootStoreModel } from '../root-store';

export const authStoreMap = (rootStore: RootStoreModel) => ({ authStore: rootStore.uiStore.authStore });
export const layoutStoreMap = (rootStore: RootStoreModel) => ({ layoutStore: rootStore.dataStore.layoutStore });
